import {CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule} from '@angular/core';
import { CloneNodePipe } from './shared/pipes/clone-node.pipe';
import { NotifyStackComponent } from './shared/notify-stack/notify-stack.component';
import { MergePanelComponent } from './shared/merge-panel/merge-panel.component';
import { AddAddressComponent } from './lab-manager/dialogs/add-address/add-address.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { UiKitModule } from './ui-kit/ui-kit.module';
import { BugReportModule } from './bug-report/bug-report.module';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import {DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule, NativeDateAdapter} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';


import { AppRoutingModule } from './app-routing.module';
import { FieldInspectionModule } from './field-inspection/field-inspection.module';
import { AppComponent } from './app.component';
import { LightboxModule } from 'ngx-lightbox';

import { NgxChartsModule } from '@swimlane/ngx-charts';
// import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxGalleryModule } from 'ngx-gallery-9';
// import { NgxImageZoomModule } from 'ngx-image-zoom';
import { environment } from 'src/environments/environment';
import { ComboChartComponent, ComboSeriesVerticalComponent } from './combo-chart';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AllPinsDeleteComponent } from './dialogs/all-pins-delete/all-pins-delete.component';
import { DateRangeComponent } from './dialogs/date-range/date-range.component';
import { OverlayAllDialogComponent } from './dialogs/overlay-all-dialog/overlay-all-dialog.component';
import { PinClearComponent } from './dialogs/pin-clear/pin-clear.component';
import { PinDeleteComponent } from './dialogs/pin-delete/pin-delete.component';
import { PinDescriptionComponent } from './dialogs/pin-description/pin-description.component';
import { RainMeterSelectionComponent } from './dialogs/rain-meter-selection/rain-meter-selection.component';
import { RainfallCaptureComponent } from './dialogs/rainfall-capture/rainfall-capture.component';
import { SavePinComponent } from './dialogs/save-pin/save-pin.component';
import { VcDeleteConfirmationComponent } from './dialogs/vc-delete-confirmation/vc-delete-confirmation.component';
import { VcFilterComponent } from './dialogs/vc-filter/vc-filter.component';
import { FieldComponent } from './field/field.component';
import { LandingComponent } from './public/landing/landing.component';
import { MappingComponent } from './mapping/mapping.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { PriorityGroupsComponent } from './priority-groups/priority-groups.component';
import { ProfileComponent } from './profile/profile.component';
import { TenantsComponent } from './tenants/tenants.component';
import { VirtualConsultantComponent } from './virtual-consultant/virtual-consultant.component';


import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';
import { ChangeLanguageComponent } from './dialogs/change-language/change-language.component';
import { RankingsComponent } from './rankings/rankings.component';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AddFarmComponent } from './dialogs/add-farm/add-farm.component';
import { AddFieldComponent } from './dialogs/add-field/add-field.component';
import { DeleteFarmComponent } from './dialogs/delete-farm/delete-farm.component';
import { DeleteFieldComponent } from './dialogs/delete-field/delete-field.component';
import { DeleteIndentFieldComponent } from './dialogs/delete-indent-field/delete-indent-field.component';
import { DeleteInsideFieldComponent } from './dialogs/delete-inside-field/delete-inside-field.component';
import { EditFieldComponent } from './dialogs/edit-field/edit-field.component';
import { FieldOptionsComponent } from './dialogs/field-options/field-options.component';
import { NewAreaComponent } from './dialogs/new-area/new-area.component';
import { NewFieldComponent } from './dialogs/new-field/new-field.component';
import { OverlayAnalysisDialogComponent } from './dialogs/overlay-analysis-dialog/overlay-analysis-dialog.component';
import { SaveChangesComponent } from './dialogs/save-changes/save-changes.component';
import { StopDrawingComponent } from './dialogs/stop-drawing/stop-drawing.component';
import { HttpRequestInterceptor } from './http-request-interceptor';
import { RegistrationComponent } from './public/registration/registration.component';
import {AutoFocusDirective} from './public/registration/auto-focus-directive';
import { ActivationComponent } from './public/activation/activation.component';
import { RegisterSuccessComponent } from './public/register-success/register-success.component';
import { ConfirmProfileDeleteComponent } from './dialogs/confirm-profile-delete/confirm-profile-delete.component';


import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';

import { provideAppCheck, initializeAppCheck, ReCaptchaV3Provider } from '@angular/fire/app-check';
import {provideFirebaseApp, initializeApp} from '@angular/fire/app';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatMenuModule} from '@angular/material/menu';
import {MatListModule} from '@angular/material/list';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatDialogModule} from '@angular/material/dialog';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatDividerModule} from '@angular/material/divider';

import { RenameFarmComponent } from './dialogs/rename-farm/rename-farm.component';
import { MapDataFarmComponent } from './map-data/map-data-farm/map-data-farm.component';
import { MapDataFieldComponent } from './map-data/map-data-field/map-data-field.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { AutoFocusDirectiveDirective } from './Custom-Directives-Pipes/auto-focus-directive.directive';
import {OrderByPipe} from './Custom-Directives-Pipes/order-by.pipe';
import {TruncateDecimalsPipe} from './Custom-Directives-Pipes/truncate-decimals.pipe';
import { OrderTrackingComponent } from './order-to-cash/components-otc/order-tracking/order-tracking.component';
import { OrderHistoryComponent } from './order-to-cash/components-otc/order-history/order-history.component';
import { OrderHistoryEventComponent } from './order-to-cash/components-otc/order-history/order-history-event/order-history-event.component';
import { OrderHistoryEventDetailComponent } from './order-to-cash/components-otc/order-history/order-history-event-detail/order-history-event-detail.component';
import { OrderComponent } from './order-to-cash/components-otc/order-manager/order/order.component';
import {MyOrdersComponent} from "./order-to-cash/components-otc/order-manager/my-orders/my-orders.component";
import { ApprovalsComponent } from './order-to-cash/components-otc/order-manager/approvals/approvals.component';
import { FilterMyOrdersComponent } from './order-to-cash/components-otc/dialogs-otc/filter-my-orders/filter-my-orders.component';
import { OrderManagerComponent } from './order-to-cash/components-otc/order-manager/order-manager/order-manager.component';
import { AddNoteComponent } from './order-to-cash/components-otc/dialogs-otc/add-note/add-note.component';
import { AttachItemComponent } from './order-to-cash/components-otc/dialogs-otc/attach-item/attach-item.component';
import { RemoveNoteComponent } from './order-to-cash/components-otc/dialogs-otc/remove-note/remove-note.component';
import { EditNoteComponent } from './order-to-cash/components-otc/dialogs-otc/edit-note/edit-note.component';
import { RemoveAttachmentComponent } from './order-to-cash/components-otc/dialogs-otc/remove-attachment/remove-attachment.component';
import { EditAttachmentComponent } from './order-to-cash/components-otc/dialogs-otc/edit-attachment/edit-attachment.component';
import {AddAltAddressComponent} from "./order-to-cash/components-otc/dialogs-otc/add-alt-address/add-alt-address.component";
import { AddCoOpComponent } from './order-to-cash/components-otc/dialogs-otc/add-co-op/add-co-op.component';
import { ClearItemsComponent } from './order-to-cash/components-otc/dialogs-otc/clear-items/clear-items.component';
import { RecallConfirmationComponent } from './order-to-cash/components-otc/dialogs-otc/recall-confirmation/recall-confirmation.component';
import { AddItemComponent } from './order-to-cash/components-otc/dialogs-otc/add-item/add-item.component';
import { RemoveItemComponent } from './order-to-cash/components-otc/dialogs-otc/remove-item/remove-item.component';
import { RemoveOrderComponent } from './order-to-cash/components-otc/dialogs-otc/remove-order/remove-order.component';
import { OrderBackComponent } from './order-to-cash/components-otc/dialogs-otc/order-back/order-back.component';
import { SubmitToSapComponent } from './order-to-cash/components-otc/dialogs-otc/submit-to-sap/submit-to-sap.component';
import { ApproveOrderComponent } from './order-to-cash/components-otc/dialogs-otc/approve-order/approve-order.component';
import { RejectOrderComponent } from './order-to-cash/components-otc/dialogs-otc/reject-order/reject-order.component';
import {CurrencyPipe, NgOptimizedImage} from "@angular/common";
import { CreateNewOrderComponent } from './order-to-cash/components-otc/dialogs-otc/create-new-order/create-new-order.component';
import { RemoveAriaOwnsDirective } from './Custom-Directives-Pipes/remove-aria-owns.directive';
import { NewSavePinComponent } from './dialogs/pin-rework-dialogs/new-save-pin/new-save-pin.component';
import { InspectorAssignmentComponent } from './dialogs/pin-rework-dialogs/inspector-assignment/inspector-assignment.component';
import { FieldInspectionDialogComponent, PreconditionErrorDialogComponent, UnsavedChangesDialogComponent } from './dialogs/pin-rework-dialogs/field-inspection-dialog/field-inspection-dialog.component';
import {NewSaveGridComponent} from "./dialogs/sampling-grid-dialogs/new-save-grid/new-save-grid/new-save-grid.component";
import { PinManagerComponent } from './pin-reworks/pin-manager/pin-manager.component';
import { CustomDatepickerComponent } from './shared/custom-datepicker/custom-datepicker.component';
import { AllPinsComponent } from './pin-reworks/all-pins/all-pins.component';

import {MatTableModule} from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { SoilPinSamplesComponent } from './dialogs/pin-rework-dialogs/soil-pin-samples/soil-pin-samples.component';
import { NewDeletePinComponent } from './dialogs/pin-rework-dialogs/new-delete-pin/new-delete-pin.component';
import { AddNewGroupComponent } from './dialogs/add-new-group/add-new-group.component';
import { VirtualConsultantPinComponent } from './dialogs/pin-rework-dialogs/virtual-consultant-pin/virtual-consultant-pin.component';
import { MarkerPinComponent } from './dialogs/pin-rework-dialogs/marker-pin/marker-pin.component';
import { ConvertPinComponent } from './dialogs/pin-rework-dialogs/convert-pin/convert-pin.component';
import { SoftTissuePinSamplesComponent } from './dialogs/pin-rework-dialogs/soft-tissue-pin-samples/soft-tissue-pin-samples.component';
import { DeleteSampleComponent } from './dialogs/delete-sample/delete-sample.component';
import { ViewSavedPinComponent } from './dialogs/pin-rework-dialogs/view-saved-pin/view-saved-pin.component';
import { WaterPinComponent } from './dialogs/pin-rework-dialogs/water-pin/water-pin.component';
import { DiseasePinComponent } from './dialogs/pin-rework-dialogs/disease-pin/disease-pin.component';
import { PestPinComponent } from './dialogs/pin-rework-dialogs/pest-pin/pest-pin.component';
import { AddEditSoilSampleComponent } from './dialogs/pin-rework-dialogs/add-edit-soil-sample/add-edit-soil-sample.component';
import { AddEditSoftTissueSampleComponent } from './dialogs/pin-rework-dialogs/add-edit-soft-tissue-sample/add-edit-soft-tissue-sample.component';
import { SampleGroupsComponent } from './pin-reworks/sample-groups/sample-groups.component';
import { AllSamplesComponent } from './pin-reworks/all-samples/all-samples.component';
import { SampleGroupMapComponent } from './pin-reworks/sample-group-map/sample-group-map.component';
import { FieldInspectionsTabComponent } from './pin-reworks/field-inspections-tab/field-inspections-tab.component';
import { MergeGroupsComponent } from './dialogs/merge-groups/merge-groups.component';
import { MoveSampleComponent } from './dialogs/move-sample/move-sample.component';
import { UpdateGroupComponent } from './dialogs/update-group/update-group.component';
import { DeleteSampleGroupComponent } from './dialogs/delete-sample-group/delete-sample-group.component';
import { SeasonManagerComponent } from './season-manager/season-manager/season-manager.component';
import { SeasonComponent } from './season-manager/season/season.component';
import { EndSeasonComponent } from './dialogs/season-manager-dialogs/end-season/end-season.component';
import { DeleteSeasonComponent } from './dialogs/season-manager-dialogs/delete-season/delete-season.component';
import { BackToSeasonManagerComponent } from './dialogs/season-manager-dialogs/back-to-season-manager/back-to-season-manager.component';
import { CreateEditSeasonComponent } from './dialogs/season-manager-dialogs/create-edit-season/create-edit-season.component';
import { BatchSelectFieldsComponent } from './dialogs/season-manager-dialogs/batch-select-fields/batch-select-fields.component';
import { BatchUpdateComponent } from './dialogs/season-manager-dialogs/batch-update/batch-update.component';
import { BulkCostManagerComponent } from './dialogs/season-manager-dialogs/bulk-cost-manager/bulk-cost-manager.component';
import { SeasonCostingComponent } from './season-manager/season-costing/season-costing.component';
import { SeasonAdminComponent } from './season-manager/season-admin/season-admin.component';
import { SeasonBatchUpdateComponent } from './season-manager/season-batch-update/season-batch-update.component';
import { SeasonDataTableComponent } from './season-manager/season-data-table/season-data-table.component';
import { SeasonFieldOrderComponent } from './season-manager/season-field-order/season-field-order.component';
import { CreateSamplesDialogComponent } from './dialogs/season-manager-dialogs/create-samples-dialog/create-samples-dialog.component';
import { BatchCreateSamplesComponent } from './season-manager/batch-create-samples/batch-create-samples.component';
import { YearPickerComponent } from './season-manager/year-picker/year-picker.component';
import { BackCreateSeasonComponent } from './dialogs/season-manager-dialogs/back-create-season/back-create-season.component';
import { SeasonFieldInputComponent } from './season-manager/season-field-input/season-field-input.component';
import { UpdateSeasonComponent } from './dialogs/season-manager-dialogs/update-season/update-season.component';
import { SeasonFieldAdminFieldsComponent } from './season-manager/season-field-admin-fields/season-field-admin-fields.component';
import { SeasonFieldAdminSeasonsComponent } from './season-manager/season-field-admin-seasons/season-field-admin-seasons.component';
import { EditFieldLinkSeasonComponent } from './season-manager/edit-field-link-season/edit-field-link-season.component';
import { LinkFieldToSeasonComponent } from './dialogs/season-manager-dialogs/link-field-to-season/link-field-to-season.component';
import { SaveLinkDataComponent } from './dialogs/season-manager-dialogs/save-link-data/save-link-data.component';
import { DownloadSatelliteReportComponent } from './dialogs/download-satellite-report/download-satellite-report/download-satellite-report.component';
import { NxNoScrollDirective } from './directives/nx-no-scroll.directive';
import { FieldDetailsComponent } from './dialogs/field-details/field-details.component';
import { OrderByDescriptionPipe } from './Custom-Directives-Pipes/order-by-description.pipe';
import { LabSubmissionsComponent } from './lab-manager/lab-submissions/lab-submissions.component';
import { CreateLabSubmissionComponent } from './dialogs/lab-manager/create-lab-submission/create-lab-submission.component';
import { LabManagerComponent } from './lab-manager/lab-manager.component';
import { LabSubmissionDetailComponent } from './lab-manager/lab-submission-detail/lab-submission-detail.component';
import { LabSamplesComponent } from './lab-manager/lab-samples/lab-samples.component';
import { LabCostCalculatorComponent } from './lab-manager/lab-cost-calculator/lab-cost-calculator.component';
import { LabAnalysisRequiredComponent } from './lab-manager/lab-analysis-required/lab-analysis-required.component';
import { DraftConfirmationDialogComponent } from './dialogs/draft-confirmation-dialog/draft-confirmation-dialog.component';
import { DownloadDialogComponent } from './dialogs/lab-manager/download-dialog/download-dialog.component';
import { AnalysisRequiredDialogComponent } from './dialogs/lab-manager/analysis-required-dialog/analysis-required-dialog.component';
import { ResultsProblemsDialogComponent } from './dialogs/lab-manager/results-problems-dialog/results-problems-dialog.component';
import { ResultsProblemListComponent } from './dialogs/lab-manager/results-problem-list/results-problem-list.component';
import { ResultsUploadDialogComponent } from './dialogs/lab-manager/results-upload-dialog/results-upload-dialog.component';
import { SamplesTableComponent } from './lab-manager/lab-samples/samples-table/samples-table.component';
import { AddSamplesDialogComponent } from './dialogs/lab-manager/add-samples-dialog/add-samples-dialog.component';
import { UploadFileComponent } from './dialogs/upload-file/upload-file.component';
import { CopyOrderComponent } from './order-to-cash/components-otc/dialogs-otc/copy-order/copy-order.component';
import { LoginComponent } from './public/login/login.component';
import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';
import { ViewPrivacyDialogComponent } from './dialogs/view-privacy-dialog/view-privacy-dialog.component';
import { NTesterPinComponent } from './dialogs/pin-rework-dialogs/n-tester-pin/n-tester-pin.component';
import { YieldEstimationPinComponent } from './dialogs/pin-rework-dialogs/yield-estimation-pin/yield-estimation-pin.component';
import { TenantViewComponent } from './tenant-view/tenant-view.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { RecommendationsComponent } from './recommendation-manager/recommendations/recommendations.component';
import { CreateRecommendationComponent } from './recommendation-manager/create-recommendation/create-recommendation.component';
import { CreateSoilCropNutritionComponent } from './soil-crop-nutrition/components/create-soil-crop-nutrition/create-soil-crop-nutrition.component';
import { MatTreeModule } from '@angular/material/tree';
import { CalcSettingsDialogComponent } from './recommendation-manager/dialogs/calc-settings-dialog/calc-settings-dialog.component';
import { RecommendationDetailsComponent } from './recommendation-manager/recommendation-details/recommendation-details.component';
import { LeafRecommendationComponent } from './recommendation-manager/leaf-recommendation/leaf-recommendation.component';
import { LabResultsComponent } from './lab-manager/lab-results/lab-results.component';
import { DateRangeSelectorComponent } from './Reuseable-Components/date-range-selector/date-range-selector.component';
import { FieldDashboardViewComponent } from './field-dashboard-view/field-dashboard-view.component';
import { IrrigationChartComponent } from './field-dashboard-view/irrigation-chart/irrigation-chart.component';
import { FieldMapComponent } from './field-dashboard-view/field-map/field-map.component';
import { FieldAnalysisComponent } from './field-dashboard-view/field-analysis/field-analysis.component';
import { FieldLinkEditorComponent } from './field-dashboard-view/field-analysis/field-link-editor/field-link-editor.component';
import { IntegrationDrawerComponent } from './field-dashboard-view/integration-status/integration-drawer.component';
import { IntegrationThisFieldComponent } from './field-dashboard-view/integration-status/integration-this-field.component';
import { IntegrationAllComponent } from './field-dashboard-view/integration-status/integration-all.component';
import { IntegrationPillComponent } from './field-dashboard-view/integration-status/integration-pill.component';
import { DrawerTimePipe } from './field-dashboard-view/integration-status/drawer-time.pipe';
import { CostBreakdownComponent } from './field-dashboard-view/cost-breakdown/cost-breakdown.component';
import { NdviChartComponent } from './field-dashboard-view/ndvi-chart/ndvi-chart.component';
import { CropSprayAnalysisComponent } from './field-dashboard-view/crop-spray-analysis/crop-spray-analysis.component';
import { CropBioComponent } from './field-dashboard-view/crop-bio/crop-bio.component';
import { MacronutrientsComponent } from './field-dashboard-view/macronutrients/macronutrients.component';
import { MicronutrientsComponent } from './field-dashboard-view/micronutrients/micronutrients.component';
import { GibberellinComponent } from './field-dashboard-view/gibberellin/gibberellin.component';
import {formatDate} from "@angular/common";
import { SeasonFieldDetailsComponent } from './season-manager/season-field-input/season-field-details/season-field-details.component';
import { FilterDialogComponent } from './recommendation-manager/dialogs/filter-dialog/filter-dialog.component';
import { PinExportFilterComponent } from './dialogs/pin-rework-dialogs/pin-export-filter/pin-export-filter.component';
import { EcoFabSpeedDialComponent, EcoFabSpeedDialActionsComponent, EcoFabSpeedDialTriggerComponent } from '@ecodev/fab-speed-dial';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { ApprovedOrdersComponent } from './order-to-cash/components-otc/order-manager/approved-orders/approved-orders.component';
import { DownloadReportDialogComponent } from './order-to-cash/components-otc/dialogs-otc/download-report-dialog/download-report-dialog.component';import { AnalysisSequenceComponent } from './sequencing/analysis-sequence/analysis-sequence.component';
import { SequenceCardComponent } from './sequencing/sequence-card/sequence-card.component';
import { GriddingComponent } from './gridding/gridding.component';
import { GridManagerDialogComponent } from './dialogs/grid-manager-dialog/grid-manager-dialog.component';
import { ConfirmGridCloseComponent } from './dialogs/confirm-grid-close/confirm-grid-close.component';
import { WeatherForecastComponent } from './weather-forecast/weather-forecast.component';

import { provideUnleashProxy } from '@karelics/angular-unleash-proxy-client';
import { RetrievePinGriddingComponent } from './dialogs/pin-rework-dialogs/retrieve-pin-gridding/retrieve-pin-gridding.component';
import { LabSoftTissueResultsTableComponent } from './lab-manager/lab-soft-tissue-results-table/lab-soft-tissue-results-table.component';
import { LabSoilResultsTableComponent } from './lab-manager/lab-soil-results-table/lab-soil-results-table.component';
import { CustomAnalysisSequenceComponent } from './sequencing/custom-analysis-sequence/custom-analysis-sequence.component';
import { CustomSequenceSelectionComponent } from './sequencing/custom-sequence-selection/custom-sequence-selection.component';
import { ChemicalCompareComponent } from './chemical-compare/chemical-compare.component';
import { JdConnectComponent } from './john-deere/pages/connect/jd-connect.component';
import { JdCallbackComponent } from './john-deere/pages/callback/jd-callback.component';
import { JdConnectedComponent } from './john-deere/pages/connected/jd-connected.component';
import { FoConnectComponent } from './field-ops/pages/connect/fo-connect.component';
import { FoCallbackComponent } from './field-ops/pages/callback/fo-callback.component';
import { FoConnectedComponent } from './field-ops/pages/connected/fo-connected.component';
import { VrtFinaliseDialogComponent } from './dialogs/vrt-finalise-dialog/vrt-finalise-dialog.component';
import { VrtNewVersionDialogComponent } from './dialogs/vrt-new-version-dialog/vrt-new-version-dialog.component';
import { VrtDownloadDialogComponent } from './dialogs/vrt-download-dialog/vrt-download-dialog.component';
import { AnalysisOrderingDefinitionsComponent } from './map-data/analysis-ordering-definitions/analysis-ordering-definitions.component';

export const PICK_FORMATS = {
    parse: {dateInput: {month: 'short', year: 'numeric', day: 'numeric'}},
    display: {
        dateInput: 'input',
        monthYearLabel: {year: 'numeric', month: 'short'},
        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
        monthYearA11yLabel: {year: 'numeric', month: 'long'}
    }
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@Injectable()
class PickDateAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: Object): string {
        if (displayFormat === 'input') {
            return formatDate(date,'yyyy-MM-dd',this.locale);
        } else {
            return formatDate(date,'MMM yyyy',this.locale);
        }
    }
}

const modules = [
    TranslateModule,
    BrowserModule,
  AppRoutingModule,
  FieldInspectionModule,
  MatIconModule,
  MatTabsModule,
  MatButtonModule,
  MatMenuModule,
  MatCardModule,
  MatExpansionModule,
  MatFormFieldModule,
  FontAwesomeModule,
  MatInputModule,
  MatListModule,
  MatRadioModule,
  FormsModule,
  MatSelectModule,
  MatOptionModule,
  MatBottomSheetModule,
  ReactiveFormsModule,
  MatSnackBarModule,
  MatDialogModule,
  DragDropModule,
  BrowserModule,
  MatTooltipModule,
  MatProgressBarModule,
  MatDatepickerModule,
  MatNativeDateModule,
  NgxChartsModule,
  MatSlideToggleModule,
  MatCheckboxModule,
  MatTreeModule,
  LightboxModule,
  GoogleMapsModule,
  UiKitModule,
  // Eager, not lazy: the error handler and the failure interceptor have to be in place before
  // the first navigation, because the errors most worth capturing happen before the user arrives.
  BugReportModule,
  MatBadgeModule,
  // NgApexchartsModule,
  // NgxImageZoomModule,
  // NgxGalleryModule,
  MatAutocompleteModule,
  ReactiveFormsModule,
  BrowserAnimationsModule,
  MatSelectModule,
  MatFormFieldModule,
  NgxMatSelectSearchModule,
  NgxSpinnerModule,
  // NgxLongPress2Module,
  MatProgressSpinnerModule,
  MatIconModule,
  MatTabsModule,
  MatTableModule,
  MatPaginatorModule,
  MatDividerModule,
  EcoFabSpeedDialComponent,
  EcoFabSpeedDialActionsComponent,
  EcoFabSpeedDialTriggerComponent
];

const internalModules = [
    AppComponent,
    RegistrationComponent,
    ActivationComponent,
    NavBarComponent,
    DashboardComponent,
    ProfileComponent,
    TenantsComponent,
    MappingComponent,
    FieldComponent,
    AnalysisSequenceComponent,
    SavePinComponent,
    PinDescriptionComponent,
    PinDeleteComponent,
    PinClearComponent,
    AllPinsDeleteComponent,
    RainMeterSelectionComponent,
    RainfallCaptureComponent,
    ComboChartComponent,
    ComboSeriesVerticalComponent,
    VirtualConsultantComponent,
    DateRangeComponent,
    VcFilterComponent,
    LandingComponent,
    VcDeleteConfirmationComponent,
    OverlayAllDialogComponent,
    PriorityGroupsComponent,
    ChangeLanguageComponent,
    RankingsComponent,
    OverlayAnalysisDialogComponent,
    AddFarmComponent,
    DeleteFarmComponent,
    AddFieldComponent,
    SaveChangesComponent,
    FieldOptionsComponent,
    DeleteFieldComponent,
    EditFieldComponent,
    NewFieldComponent,
    DeleteInsideFieldComponent,
    DeleteIndentFieldComponent,
    NewAreaComponent,
    StopDrawingComponent,
    ConfirmProfileDeleteComponent,
    RegisterSuccessComponent,
    DownloadSatelliteReportComponent,
    GridManagerDialogComponent,
    ConfirmGridCloseComponent,
    GriddingComponent,
    CustomAnalysisSequenceComponent,
    CustomSequenceSelectionComponent,
    AnalysisOrderingDefinitionsComponent
];

@NgModule({
  declarations: [
    ...internalModules,
      AutoFocusDirective,
      OrderByPipe,

      RenameFarmComponent,
      MapDataFarmComponent,
      MapDataFieldComponent,
      ChemicalCompareComponent,
      JdConnectComponent,
      JdCallbackComponent,
      JdConnectedComponent,
      FoConnectComponent,
      FoCallbackComponent,
      FoConnectedComponent,
      VrtFinaliseDialogComponent,
      VrtNewVersionDialogComponent,
      VrtDownloadDialogComponent,
      AutoFocusDirectiveDirective,
      OrderTrackingComponent,
      OrderHistoryComponent,
      OrderHistoryEventComponent,
      OrderHistoryEventDetailComponent,
      MyOrdersComponent,
      OrderComponent,
      ApprovalsComponent,
      FilterMyOrdersComponent,
      OrderManagerComponent,
      AddAltAddressComponent,
      AddNoteComponent,
      AttachItemComponent,
      RemoveNoteComponent,
      EditNoteComponent,
      RemoveAttachmentComponent,
      EditAttachmentComponent,
      AddCoOpComponent,
      ClearItemsComponent,
      RecallConfirmationComponent,
      AddItemComponent,
      RemoveItemComponent,
      RemoveOrderComponent,
      OrderBackComponent,
      SubmitToSapComponent,
      ApproveOrderComponent,
      RejectOrderComponent,
      CreateNewOrderComponent,
      RemoveAriaOwnsDirective,
      NewSavePinComponent,
      InspectorAssignmentComponent,
      FieldInspectionDialogComponent,
      PreconditionErrorDialogComponent,
      UnsavedChangesDialogComponent,
      NewSaveGridComponent,
      PinManagerComponent,
      CustomDatepickerComponent,
      AllPinsComponent,
      SampleGroupsComponent,
      FieldInspectionsTabComponent,
      SoilPinSamplesComponent,
      AddEditSoilSampleComponent,
      NewDeletePinComponent,
      SoftTissuePinSamplesComponent,
      AddNewGroupComponent,
      VirtualConsultantPinComponent,
      MarkerPinComponent,
      ConvertPinComponent,
      AddEditSoftTissueSampleComponent,
      DeleteSampleComponent,
      ViewSavedPinComponent,
      WaterPinComponent,
      DiseasePinComponent,
      PestPinComponent,
      AllSamplesComponent,
      SampleGroupMapComponent,
      MergeGroupsComponent,
      MoveSampleComponent,
      UpdateGroupComponent,
      DeleteSampleGroupComponent,
      SeasonManagerComponent,
      SeasonComponent,
      EndSeasonComponent,
      DeleteSeasonComponent,
      BackToSeasonManagerComponent,
      CreateEditSeasonComponent,
      BatchSelectFieldsComponent,
      BatchUpdateComponent,
      BulkCostManagerComponent,
      SeasonCostingComponent,
      SeasonAdminComponent,
      SeasonBatchUpdateComponent,
      BackCreateSeasonComponent,
      SeasonDataTableComponent,
      SeasonFieldOrderComponent,
      CreateSamplesDialogComponent,
      BatchCreateSamplesComponent,
      YearPickerComponent,
      SeasonFieldInputComponent,
      UpdateSeasonComponent,
      SeasonFieldAdminFieldsComponent,
      SeasonFieldAdminSeasonsComponent,
      EditFieldLinkSeasonComponent,
      LinkFieldToSeasonComponent,
      SaveLinkDataComponent,
      DownloadSatelliteReportComponent,
      LabSubmissionsComponent,
      CreateLabSubmissionComponent,
      LabManagerComponent,
      LabSubmissionDetailComponent,
      LabSamplesComponent,
      LabCostCalculatorComponent,
      LabAnalysisRequiredComponent,
      DraftConfirmationDialogComponent,
      DownloadDialogComponent,
      AnalysisRequiredDialogComponent,
      ResultsProblemsDialogComponent,
      ResultsProblemListComponent,
      ResultsUploadDialogComponent,
      SamplesTableComponent,
      AddSamplesDialogComponent,
      NxNoScrollDirective,
      FieldDetailsComponent,
      OrderByDescriptionPipe,
      RecommendationsComponent,
      CreateRecommendationComponent,
      CreateSoilCropNutritionComponent,
      CalcSettingsDialogComponent,
      RecommendationDetailsComponent,
      LeafRecommendationComponent,
      LoginComponent,
      ForgotPasswordComponent,
      ViewPrivacyDialogComponent,
      UploadFileComponent,
      CopyOrderComponent,
      NTesterPinComponent,
      YieldEstimationPinComponent,
      TenantViewComponent,
      SideNavComponent,
      DateRangeSelectorComponent,
      SeasonFieldDetailsComponent,
      LabResultsComponent,
      FilterDialogComponent,
      PinExportFilterComponent,
      FieldDashboardViewComponent,
      IrrigationChartComponent,
      FieldMapComponent,
      FieldAnalysisComponent,
      FieldLinkEditorComponent,
      IntegrationDrawerComponent,
      IntegrationThisFieldComponent,
      IntegrationAllComponent,
      IntegrationPillComponent,
      DrawerTimePipe,
      CostBreakdownComponent,
      NdviChartComponent,
      CropSprayAnalysisComponent,
      CropBioComponent,
      MacronutrientsComponent,
      MicronutrientsComponent,
      GibberellinComponent,

      ApprovedOrdersComponent,
      DownloadReportDialogComponent,
      RetrievePinGriddingComponent,
      LabSoftTissueResultsTableComponent,
      LabSoilResultsTableComponent
  ],
    imports: [
        TruncateDecimalsPipe,
        ...modules,
        CloneNodePipe,
        NotifyStackComponent,
        MergePanelComponent,
        AddAddressComponent,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgxEchartsModule.forRoot({
            echarts
        }),
        MatButtonToggleModule,
        MatTableModule,
        MatPaginatorModule,
        NgOptimizedImage,
        WeatherForecastComponent,
        SequenceCardComponent
    ],
  exports: [...modules],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: Window, useValue: window },
    NavBarComponent,
    CookieService,
    CurrencyPipe,
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
      {provide: DateAdapter, useClass: PickDateAdapter},
      {provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS},
        provideHttpClient(withInterceptorsFromDi()),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideStorage(() => getStorage()),
        provideAnalytics(() => getAnalytics()),
        provideAuth(() => getAuth()),
        provideDatabase(() => getDatabase()),
        provideAppCheck(() => {
            const provider = new ReCaptchaV3Provider(environment.reCaptcha.siteKey);
            return initializeAppCheck(undefined, {provider, isTokenAutoRefreshEnabled: true});
        }),
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: appInitializerFactory,
    //   deps: [TranslateService, Injector],
    //   multi: true
    // }

  provideUnleashProxy({
    url: environment.unleash.url,
    clientKey: environment.unleash.clientKey,
    appName: environment.unleash.appName,
    disableRefresh: true,
    disableMetrics: true,
  }),

  ],
  bootstrap: [AppComponent]
})
export class AppModule {}

// export function appInitializerFactory(translate: TranslateService, injector: Injector) {
//   return () => new Promise<any>((resolve: any) => {
//     const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
//     locationInitialized.then(() => {
//       const langToSet = 'es'
//       translate.setDefaultLang('en');
//       translate.use(langToSet).subscribe(() => {
//         console.info(`Successfully initialized '${langToSet}' language.'`);
//       }, err => {
//         console.error(`Problem with '${langToSet}' language initialization.'`);
//       }, () => {
//         resolve(null);
//       });
//     });
//   });
// }
